import React, { memo } from 'react';
import { Highlight } from 'react-instantsearch-hooks-web';
import Image from '../../Image/Image';
import CustomLink from '../../CustomLink/CustomLink';
import SbImage from '../../SbImage/SbImage';

interface HeaderSearchResultHitProps {
  hit: any;
}

const HeaderSearchResultHit: React.FC<HeaderSearchResultHitProps> = ({
  hit,
}) => {
  return (
    <CustomLink
      url={hit.full_slug}
      label={hit.heading}
      className="flex items-start justify-start gap-x-4 group"
    >
      <div className="bg-border/light w-16 h-16 flex-shrink-0">
        {hit.image?.filename && (
          <SbImage asset={hit.image} options={{ width: 64, height: 64, sizes: { base: 128 } }} />
        )}
      </div>
      <div className="space-y-1">
        {hit.heading && (
          <p className="font-bold group-hover:text-text/body-primary-highlight xl:text-lg">
            <Highlight
              attribute="heading"
              classNames={{
                highlighted: 'bg-button/primary-bg text-system/white',
              }}
              hit={hit}
            />
          </p>
        )}
        {hit.body && (
          <p className="text-sm xl:text-base">
            <Highlight
              attribute="body"
              classNames={{
                highlighted: 'bg-button/primary-bg text-system/white',
              }}
              hit={hit}
            />
          </p>
        )}
      </div>
    </CustomLink>
  );
};

export default memo(HeaderSearchResultHit);
